import { SearchType } from "../../types";
import FullscreenModal from "../FullscreenModal";
import SearchComponent from "../SearchComponent";
import { SearchResult } from "../../api/types";

function SearchModal(props: {
  hideModal: boolean;
  searchType: SearchType;
  handleResultClicked: (res: SearchResult) => void;
  handleSearchClosed: () => void;
  clearOnClick?: boolean;
  disableSearch?: boolean;
  validationFunction?: (res: SearchResult) => boolean;
}) {
  const {
    hideModal,
    searchType,
    handleResultClicked,
    handleSearchClosed,
    clearOnClick,
    disableSearch,
    validationFunction,
  } = props;
  const display = hideModal ? "none" : "flex";

  return (
    <FullscreenModal
      style={{ background: { display } }}
      onClose={handleSearchClosed}
    >
      <SearchComponent
        searchType={searchType}
        handleResultClicked={handleResultClicked}
        clearOnClick={clearOnClick}
        disableSearch={disableSearch}
        validationFunction={validationFunction}
      />
    </FullscreenModal>
  );
}

export default SearchModal;
